import React, { useState } from "react";
import axios from "axios";
import qnuLogo from "../assets/logoQNU.png";
import securityIcon from "../assets/icon/s.png";
import { API_BASE_URL } from "../config/api";

function WebScrapeTab({ onEventsLoaded, disabled }) {
  const getAcademicYears = () => {
    const years = [];
    const currentYear = new Date().getFullYear();

    for (let index = 0; index < 3; index += 1) {
      const startYear = currentYear - index;
      years.push(`${startYear}-${startYear + 1}`);
    }

    return years;
  };

  const [mssv, setMssv] = useState("");
  const [password, setPassword] = useState("");
  const [academicYear, setAcademicYear] = useState("");
  const [semester, setSemester] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [status, setStatus] = useState(null);

  const academicYears = getAcademicYears();

  const getErrorMessage = (err) => {
    const details = err.response?.data?.details;

    return (
      (Array.isArray(details?.errors) ? details.errors.join(", ") : null) ||
      details?.message ||
      (typeof details === "string" ? details : null) ||
      err.response?.data?.message ||
      err.message ||
      "Không lấy được thời khóa biểu"
    );
  };

  const handleFetch = async (event) => {
    event.preventDefault();

    if (!mssv.trim() || !password.trim()) {
      setStatus({
        type: "error",
        message: "Vui lòng nhập mã số sinh viên và mật khẩu.",
      });
      return;
    }

    if (!academicYear.trim()) {
      setStatus({ type: "error", message: "Vui lòng chọn năm học." });
      return;
    }

    if (!semester.trim()) {
      setStatus({ type: "error", message: "Vui lòng chọn học kỳ." });
      return;
    }

    try {
      setIsLoading(true);
      setStatus(null);

      const res = await axios.post(`${API_BASE_URL}/api/scrape/web`, {
        mssv: mssv.trim(),
        password,
        academicYear,
        semester,
      });

      const courses = res.data.data || [];
      setStatus({
        type: "success",
        message: `Lấy thành công ${courses.length} môn học từ cổng QNU.`,
      });
      onEventsLoaded(courses);
    } catch (err) {
      setStatus({
        type: "error",
        message: `Lấy dữ liệu thất bại. ${getErrorMessage(err)}`,
      });
    } finally {
      setIsLoading(false);
    }
  };

  const isDisabled = isLoading || disabled;

  return (
    <>
      <article className="source-card">
        <h3 className="card-title">
          <span className="card-title-icon" aria-hidden="true">
            <img src={qnuLogo} alt="" className="card-title-icon-image" />
          </span>
          <span>Đăng nhập Cổng QNU</span>
        </h3>
        <p className="card-description">
          Đăng nhập vào cổng thông tin sinh viên QNU để tự động lấy thời khóa
          biểu học kỳ hiện tại.
        </p>

        <form className="portal-form" onSubmit={handleFetch}>
          <div className="form-field">
            <label htmlFor="mssv">
              Mã số sinh viên <span className="required-mark">*</span>
            </label>
            <input
              id="mssv"
              className="field-input"
              type="text"
              value={mssv}
              onChange={(event) => setMssv(event.target.value)}
              disabled={isDisabled}
              placeholder="Hãy nhập mã số sinh viên"
              autoComplete="username"
            />
          </div>

          <div className="form-field">
            <label htmlFor="portal-password">
              Mật khẩu <span className="required-mark">*</span>
            </label>
            <input
              id="portal-password"
              className="field-input"
              type="password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              disabled={isDisabled}
              placeholder="Hãy nhập mật khẩu"
              autoComplete="current-password"
            />
          </div>

          <div className="field-row">
            <div className="form-field">
              <label htmlFor="academic-year">
                Năm học <span className="required-mark">*</span>
              </label>
              <select
                id="academic-year"
                className="field-select"
                value={academicYear}
                onChange={(event) => setAcademicYear(event.target.value)}
                disabled={isDisabled}
              >
                <option value="">-- Chọn năm học --</option>
                {academicYears.map((year) => (
                  <option key={year} value={year}>
                    {year}
                  </option>
                ))}
              </select>
            </div>

            <div className="form-field">
              <label htmlFor="semester">
                Học kỳ <span className="required-mark">*</span>
              </label>
              <select
                id="semester"
                className="field-select"
                value={semester}
                onChange={(event) => setSemester(event.target.value)}
                disabled={isDisabled}
              >
                <option value="">-- Chọn học kỳ --</option>
                <option value="HK01">Học kỳ 1</option>
                <option value="HK02">Học kỳ 2</option>
                <option value="HK03">Học kỳ 3</option>
              </select>
            </div>
          </div>

          <button type="submit" className="fetch-btn" disabled={isDisabled}>
            {isLoading ? "Đang lấy dữ liệu..." : "Lấy thời khóa biểu"}
          </button>
        </form>

        {status?.type === "success" ? (
          <div className={`status-box ${status.type}`}>{status.message}</div>
        ) : null}

        <div className="helper-note helper-note-with-icon">
          <img src={securityIcon} alt="" className="helper-note-icon" />
          <span>
            Mật khẩu chỉ được dùng để đăng nhập vào web trường, không lưu lại.
          </span>
        </div>
      </article>

      {status?.type === "error" ? (
        <div className="status-overlay" role="alert" aria-live="assertive">
          <div className="status-modal status-modal-error">
            <p>{status.message}</p>
            <button
              type="button"
              className="status-modal-btn"
              onClick={() => setStatus(null)}
            >
              Đóng
            </button>
          </div>
        </div>
      ) : null}
    </>
  );
}

export default WebScrapeTab;
